import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {damUrl} from './defines';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DamService {

  baseUrl = `${damUrl}`;
  constructor(
    private _httpClient: HttpClient
  ) {
  }

  download(id: string): Observable<HttpResponse<Blob>> {
    return this._httpClient.get(`${this.baseUrl}/documents/${id}/type/BASE/download`, {
      responseType: "blob",
      observe: 'response'
    })
  }
}
